import React from 'react';
import { motion } from 'framer-motion';
import { Zap, Target, ShieldCheck, TrendingUp } from 'lucide-react';
const pillars = [{
  icon: Zap,
  title: 'Fast',
  desc: 'Deployed in days, not months.'
}, {
  icon: Target,
  title: 'Focused',
  desc: 'Targeted to the ERA moment.'
}, {
  icon: ShieldCheck,
  title: 'Authentic',
  desc: 'Real voices, real reactions.'
}, {
  icon: TrendingUp,
  title: 'Scalable',
  desc: 'A foundation for the future.'
}];
export const Slide03Approach = () => {
  return <div className="relative w-full h-full flex flex-col justify-center px-24 bg-slate-950 overflow-hidden" data-id="element-59">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-red-900/20 via-slate-950 to-slate-950" data-id="element-60" />

      <div className="relative z-10 max-w-6xl mx-auto w-full" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-62">
          <h2 className="text-5xl font-bold tracking-tight mb-6 text-white" data-id="element-63">
            A 2-week pilot.
            <br data-id="element-64" />
            <span className="text-slate-400" data-id="element-65">
              Not a 6-month transformation.
            </span>
          </h2>
        </motion.div>

        <div className="relative" data-id="element-66">
          {/* Timeline Line */}
          <div className="absolute top-1/2 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-red-600/50 to-transparent -translate-y-1/2" data-id="element-67" />

          <div className="grid grid-cols-4 gap-8 relative z-10" data-id="element-68">
            {pillars.map((pillar, index) => <motion.div key={pillar.title} initial={{
            opacity: 0,
            y: 40
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2 + index * 0.15,
            duration: 0.6
          }} className="flex flex-col items-center" data-id="element-69">
                <div className="w-20 h-20 rounded-full bg-slate-900 border border-red-500/30 flex items-center justify-center mb-6 shadow-[0_0_30px_rgba(220,38,38,0.15)] relative" data-id="element-70">
                  <div className="absolute inset-0 rounded-full bg-red-500/10 animate-pulse" data-id="element-71" />
                  <pillar.icon className="w-8 h-8 text-red-500 relative z-10" strokeWidth={1.5} data-id="element-72" />
                </div>
                <h3 className="text-2xl font-semibold text-white mb-3" data-id="element-73">
                  {pillar.title}
                </h3>
                <p className="text-slate-400 text-center font-light leading-relaxed" data-id="element-74">
                  {pillar.desc}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </div>;
};